import ejs from "ejs/ejs.min.js";

import chalanPrintTemplate from "templates/chalanPrintTemplate";

const ONES = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen",
];

const TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

const formatMoneyForPrint = (value) =>
  `Rs. ${Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const twoDigitWords = (value) => {
  if (value < 20) return ONES[value];
  return `${TENS[Math.floor(value / 10)]}${value % 10 ? ` ${ONES[value % 10]}` : ""}`;
};

const numberToIndianWords = (value) => {
  const amount = Math.floor(Number(value) || 0);
  if (amount === 0) return "Zero Rupees Only";

  const parts = [];
  const crore = Math.floor(amount / 10000000);
  const lakh = Math.floor((amount % 10000000) / 100000);
  const thousand = Math.floor((amount % 100000) / 1000);
  const hundred = Math.floor((amount % 1000) / 100);
  const remainder = amount % 100;

  if (crore) parts.push(`${numberToIndianWords(crore).replace(" Rupees Only", "")} Crore`);
  if (lakh) parts.push(`${twoDigitWords(lakh)} Lakh`);
  if (thousand) parts.push(`${twoDigitWords(thousand)} Thousand`);
  if (hundred) parts.push(`${ONES[hundred]} Hundred`);
  if (remainder) parts.push(twoDigitWords(remainder));

  return `${parts.join(" ")} Rupees Only`;
};

const formatDisplayDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formatSrNo = (value) => String(value).padStart(2, "0");

export function printChalanPdf(sale) {
  if (!sale?.items?.length) {
    return;
  }

  const totalQty = sale.items.reduce((sum, item) => sum + Number(item.qty || 0), 0);
  const totalAmount = sale.items.reduce(
    (sum, item) => sum + Number(item.qty || 0) * Number(item.mrp || 0),
    0
  );

  const printableRows = sale.items.map((item) => ({
    srNoText: formatSrNo(item.srNo),
    itemName: item.itemName,
    qty: Number(item.qty || 0),
    mrpText: formatMoneyForPrint(item.mrp),
    amountText: formatMoneyForPrint(Number(item.qty || 0) * Number(item.mrp || 0)),
  }));

  const html = ejs.render(chalanPrintTemplate, {
    companyName: sale.companyName || sale.company_name || "—",
    companySubtitle: "Chalan Print",
    companyAddress:
      "Head Office: Holding No. 82, 121 Aswini Dutta Road, South Dum Dum, PO - Dum Dum, PS - Baguiati, South Dum Dum Municipality, Distt - North 24 Paragnas, West Bengal - 700028",
    companyLegal: "CIN: U15549WB2021PTC245833    GSTN: 19AAJCB9178Q1ZJ    PAN NUMBER: AAJCB9178Q",
    chalanCode: sale.chalanCode || "—",
    saleDate: formatDisplayDate(sale.saleDate),
    assigneeTypeLabel: sale.assigneeType === "company_staff" ? "Company Staff" : "Delivery Boy",
    assigneeName: sale.assigneeName || "—",
    rows: printableRows,
    totalQty,
    totalAmount: formatMoneyForPrint(totalAmount),
    amountInWords: numberToIndianWords(totalAmount),
  });

  const printWindow = window.open("", "_blank", "width=900,height=900");
  if (!printWindow) {
    alert("Please allow popups to print chalan PDF.");
    return;
  }

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();

  setTimeout(() => {
    printWindow.print();
  }, 250);
}
